/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import { Box, Grid, styled, Tab, Tabs } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useQlik } from "../../context/Qlik";
import NativeObject from "../../components/NativeObject/NativeObject";

const LayoutCardsWrapper = styled("div")({
	alignItems: "start",
	display: "flex",
	borderRadius: "16px",
	flexDirection: "row",
	height: "100%",
	justifyContent: "start",
	paddingRight: "18px",
	width: "100%",
});

function StrategicProductsDesktop({ app, config }) {
	const notFullHd = useMediaQuery({ query: "(max-width: 1366px)" });
	const { setSwitchOnDemand } = useQlik();

	useEffect(() => {
		setSwitchOnDemand(false);
	}, []);

	return (
		<div className="app detail">
			<div className="appContent appContentOverflow detail">
				<LayoutCardsWrapper>
					<Grid container spacing={1}>
						{/* SELL OUT */}
						<Grid style={{ width: "100%" }} item xs={12} md={6}>
							<Card
								app={app}
								header={{
									hardTitle: "Ranking - Sell out",
								}}
								style={{ width: "100%", height: "60vh" }}
							>
								<NativeObject
									app={app}
									key="4ab7e24c-2d1e-45f2-b036-9fa9cff427a8"
									reference={{
										id: "4ab7e24c-2d1e-45f2-b036-9fa9cff427a8",
									}}
								/>
							</Card>
						</Grid>
						{/* POSITIV */}
						<Grid style={{ width: "100%" }} item xs={12} md={6}>
							<Card
								app={app}
								header={{
									hardTitle: "Ranking - Positivação",
								}}
								style={{ width: "100%", height: "60vh" }}
							>
								<NativeObject
									app={app}
									key="LNszEG"
									reference={{ id: "LNszEG" }}
								/>
							</Card>
						</Grid>
						{/* EVOLUTION */}
						<Grid
							style={{ width: "100%", paddingTop: "4px" }}
							item
							xs={12}
							md={12}
						>
							<Card
								app={app}
								header={{
									hardTitle: "Evolução",
								}}
								style={{ width: "100%", height: "50vh" }}
							>
								<NativeObject
									app={app}
									key="WGszjRP"
									reference={{ id: "WGszjRP" }}
									style={{ paddingTop: "4px", width: "100%", scrollX: "scroll" }}
								/>
							</Card>
						</Grid>
					</Grid>
				</LayoutCardsWrapper>
			</div>
		</div>
	);
}

StrategicProductsDesktop.defaultProps = {
	app: null,
	config: {},
};

StrategicProductsDesktop.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default StrategicProductsDesktop;
